/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import Vue from 'vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  setAlreadySubmittedUser(state, payload) {
    state.alreadySubmittedUser = payload;
  },
  updateShowThankYouEmailModal(state, payload) {
    state.showThankYouEmailModal = payload;
  },
  clearPuzzleGame(state) {
    state.puzzleGame = null;
  },
  clearLanternGame(state) {
    state.lanternGame = null;
  },
  savePuzzleGame(state, puzzle) {
    state.puzzleGame = puzzle;
  },
  saveLanternGame(state, lantern) {
    state.lanternGame = lantern;
  },
  setFreePlayPrize(state, payload) {
    state.freePlayPrize = payload;
  },
  stopTimerForInactiveUser(state) {
    console.log('stopTimerForInactiveUser/init timer for beginning');
    console.log(state.timer);
    if (state.timer) clearTimeout(state.timer);
    state.timer = null;
    state.hasDoActionFor5min = true;
  },
  initTimerForInactiveUser(state) {
    console.log('initTimerForInactiveUser');
    clearTimeout(state.timer);
    state.timer = null;
    state.timer = setTimeout(() => {
      console.log(state.timer);
      console.log('MPIKE MESA NA TA ALLAXSEI');
      state.hasDoActionFor5min = false;
      clearTimeout(state.timer);
      state.timer = null;
      console.log(state.timer);
    }, 2 * 60000);
  },
  updateCelebrityInfo(state, celebrity) {
    state.celebrityInfo = celebrity;
  },
  setRedeemedNotification(state, notificationId) {
    const matchingNotifications = state.notifications.filter(notification => notification.id === notificationId);
    if (matchingNotifications.length) {
      const { gameId } = matchingNotifications[0];
      state.notifications = state.notifications.map(notification => (notification.id === notificationId || notification.gameId === gameId ? { ...notification, readStatus: true } : notification));
      state.achievementNotificationData = state.achievementNotificationData.map(notification => (notification.id === notificationId || notification.gameId === gameId ? { ...notification, readStatus: true } : notification));
    }
  },
  setCheckedNotificationId(state, payload) {
    state.checkedNotificationId = payload.value;
  },
  setCheckedNotificationReadStatus(state, payload) {
    state.checkedNotificationReadStatus = payload.value;
  },
  setNotificationRewardId(state, payload) {
    state.notificationRewardId = payload.value;
  },
  setNotificationPrizeWon(state, payload) {
    state.notificationPrizeWon = payload.value;
  },
  setNotificationRewardName(state, payload) {
    state.notificationRewardName = payload.value;
  },
  setUserAchievements(state, achievements) {
    state.achievements = achievements.map(achievement => ({
      ...achievement,
      achievementDTOs: achievement.achievementDTOs.map(ad => ({
        ...ad,
        achievementLevelDTOs: ad.achievementLevelDTOs.map((ald, index) => ({
          ...ald,
          index,
        })),
      })),
    }));
  },
  clearBonusDailyModal(state) {
    state.bonusDailyModal = null;
  },
  saveBonusDailyModal(state, daily) {
    state.bonusDailyModal = daily;
  },
  clearPhaseBonusModalToBeDisplayed(state) {
    state.phaseBonusModalToBeDisplayed = {};
  },
  updatePhaseBonusModalToBeDisplayed(state, phase) {
    state.phaseBonusModalToBeDisplayed = phase;
  },
  savePhaseBonusList(state, bonus) {
    state.phaseBonusList = bonus;
  },
  updateOnlineStatus(state, booleanVal) {
    state.isUserConnected = booleanVal;
  },
  clearAllData(state) {
    state.hasDoActionFor5min = true;
    state.showmodalBundleId = false;
    state.notifications = [];
    state.dailyPrize = {};
    state.dailyWinners = [];
    state.dailyRank = {};
    state.weeklyPrize = {};
    state.weeklyRank = {};
    state.weeklyWinners = [];
    state.monthlyPrize = {};
    state.monthlyWinners = [];
    state.monthlyRank = {};
    state.visitorWinners = [];
    state.grandPrize = {};
  },
  setHashedPassForForgotPass(state, pass) {
    state.hashedPass = pass;
  },
  setSuccessForReoptinWith2StepVerificationVerified(state, booleanVal) {
    state.twoStepVerificationVerified = booleanVal;
  },
  setSuccessForReoptinWith2StepVerificationWrongPin(state, booleanVal) {
    state.twoStepVerificationWrongPin = booleanVal;
  },
  setSuccessForReoptinWith2StepVerificationServerError(state, booleanVal) {
    state.twoStepVerificationServerError = booleanVal;
  },
  storeNotificationsFromSocket(state, payload) {
    const { notifications } = payload;
    state.notifications.push(notifications);
    if (notifications.notificationCategoryDTO.name === 'Achievement') state.achievementNotificationData.push(notifications);
  },
  storeAchievementNotificationData(state, payload) {
    state.achievementNotificationData = payload.notifications;
  },
  setForgotPasswordInfo(state, payload) {
    state.forgotPasswordInfo = payload;
  },
  storeNotifications(state, payload) {
    state.notifications = payload.notifications;
  },
  setMoreWinnersButton(state, show) {
    state.moreWinnersButton = show;
  },
  setExtraWinners(state, payload) {
    state.extraArraysWinners = payload.value;
  },
  setWinners(state, payload) {
    state.visitorWinners = payload.value;
  },
  setMonthlyPrize(state, payload) {
    state.monthlyPrize = payload.value;
  },
  setGrandPrize(state, payload) {
    state.grandPrize = payload.value;
  },
  setDailyPrize(state, payload) {
    state.dailyPrize = payload.value;
  },
  setWeeklyPrize(state, payload) {
    state.weeklyPrize = payload.value;
  },
  setCarouselPrizes(state, payload) {
    state.carouselPrizes = payload.value;
  },
  setRequestPinResponse(state, payload) {
    state.requestPinResponse = payload.value;
  },
  setChargePinResponse(state, payload) {
    state.chargePinResponse = payload.value;
  },
  setBundles(state, payload) {
    state.storedBundles = payload.value;
  },
  setRegistrationInfo(state, payload) {
    state.registrationInfoMsisdn = payload;
  },
  setMonthlyPrizeForLeaderboard(state, payload) {
    state.monthlyPrizeForLeaderboard = payload;
  },
  setGrandPrizeForLeaderboard(state, payload) {
    state.grandPrizeForLeaderboard = payload;
  },
  setDailyPrizeForLeaderboard(state, payload) {
    state.dailyPrizeForLeaderboard = payload;
  },
  setWeeklyPrizeForLeaderboard(state, payload) {
    state.weeklyPrizeForLeaderboard = payload;
  },
  setMonthlyWinnersForLeaderboard(state, payload) {
    state.monthlyWinnersForLeaderboard = payload;
  },
  setGrandWinnersForLeaderboard(state, payload) {
    state.grandWinnersForLeaderboard = payload;
  },
  setDailyWinnersForLeaderboard(state, payload) {
    state.dailyWinnersForLeaderboard = payload;
  },
  setWeeklyWinnersForLeaderboard(state, payload) {
    state.weeklyWinnersForLeaderboard = payload;
  },
  setMonthlyRankForLeaderboard(state, payload) {
    state.monthlyRankForLeaderboard = payload;
  },
  setGrandRankForLeaderboard(state, payload) {
    state.grandRankForLeaderboard = payload;
  },
  setDailyRankForLeaderboard(state, payload) {
    state.dailyRankForLeaderboard = payload;
  },
  setWeeklyRankForLeaderboard(state, payload) {
    state.weeklyRankForLeaderboard = payload;
  },
  setAvailablePrizeTypes(state, payload) {
    state.availablePrizeTypes = payload;
  },
  setjwtFromStorage(state, jwt) {
    state.jwtInVuex = jwt;
  },
  setFirstTimeEntry(state, firstEntry) {
    state.firstTimeEntry = firstEntry;
  },
  setShowmodalForDefaultPrizeDetails(state, payload) {
    state.showmodalForDefaultPrizeDetails = payload.notificationPrizeDetailsObject;
  },
  setShowmodalForRanking(state, payload) {
    state.showmodalForRanking = {};
    state.showmodalForRanking.userLevel = payload.notificationRankingObject.userLevel;
    state.showmodalForRanking.bonusPoints = payload.notificationRankingObject.bonusPoints;
    state.showmodalForRanking.gamesEarned = payload.notificationRankingObject.gamesEarned;
  },
  setShowmodalForLevelUp(state, payload) {
    state.showmodalForLevelUp = {};
    state.showmodalForLevelUp.userLevel = payload.notificationLevelupObject.userLevel;
    state.showmodalForLevelUp.bonusPoints = payload.notificationLevelupObject.bonusPoints;
    state.showmodalForLevelUp.gamesEarned = payload.notificationLevelupObject.gamesEarned;
  },
  setUserAuthorized(state, status) {
    state.userAuthorized = status;
  },
  setProfilePath(state, profilePath1) {
    state.profilePath = profilePath1;
  },
  setBundleId(state, bundleId) {
    state.bundleId = bundleId;
  },
  setBundleData(state, payload) {
    state.bundleData = {};
    state.bundleData.currencyCode = payload.bundleDataObject.currencyCode;
    state.bundleData.price = payload.bundleDataObject.price;
    state.bundleData.numberOfGames = payload.bundleDataObject.numberOfGames;
    state.bundleData.points = payload.bundleDataObject.points;
    state.bundleData.joker = payload.bundleDataObject.joker;
    state.bundleData.numOfJokers = payload.bundleDataObject.numOfJokers;
  },
  storeThemes(state, themes) {
    state.themes = themes;
  },
  storeGameHistoryData: (state, payload) => {
    state.gameHistoryData = payload.value;
    state.gameHistoryDataForToday = state.gameHistoryData.filter(date => Vue.moment(date.timestamp).isSame(new Date(), 'day'));
    state.gameHistoryDataForOtherDays = state.gameHistoryData.filter(date => !Vue.moment(date.timestamp).isSame(new Date(), 'day'));
  },
  setOppDetails(state, payload) {
    state.opponentDetails = payload.details;
  },
  setGameDetails(state, payload) {
    state.gameDescriptionDetails = payload.details;
  },
  setShowHistory(state, show) {
    state.showHistory = show;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js